'use strict';
import React from 'react';
import {Link} from 'react-router';
import LoadingIndicator from 'client/generic/LoadingIndicator.react';
import studentInfoStore from './StudentInfo.store';

import './single-student-info.scss';

export default class StudentInfo extends React.Component {
  makeInformationList() {
    if (!studentInfoStore.hasStudentData()) {
      return <LoadingIndicator />;
    }

    const studentData = studentInfoStore.getStudentData();
    const school = studentData.getSchool();
    // predicate ensures we have a school value that isn't a default empty map
    const schoolName = school && school.getName ? school.getName() : '';
    return (
      <dl className='single-student-info-info-card-term-list'>
        <dt>
          <span className='fa fa-user single-student-info-info-card-term-list__term-icon' />
          Username
        </dt>
        <dd>{studentData.getUsername()}</dd>
        <dt>
          <span className='fa fa-envelope single-student-info-info-card-term-list__term-icon' />
          Email
        </dt>
        <dd>{studentData.getEmail()}</dd>
        {schoolName ? (
          <dt>
            <span className='fa fa-home single-student-info-info-card-term-list__term-icon' />
            School
          </dt>
        ) : null}
        {schoolName ? <dd>{schoolName}</dd> : null}
      </dl>
    );
  }

  makeClassroomsList() {
    if (!studentInfoStore.hasStudentData()) {
      return <LoadingIndicator />;
    }

    return (
      <div className='single-student-info-classroom-list'>
        {studentInfoStore
          .getStudentData()
          .getClassrooms()
          .map((classroom, key) => {
            const teachers = classroom
              .getTeachers()
              .map((teacher) => {
                const salutation = teacher.getSalutation() ? `${teacher.getSalutation()} ` : '';
                // salutation has a trailing space attached in the line above.
                return `${salutation}${teacher.getFirstName()} ${teacher.getLastName()}`;
              })
              .join(', ');
            return (
              <Link
                to={`/classes/${classroom.getId()}/students/overview`}
                className='single-student-info-classroom-list__item-link'
                key={key}
              >
                <div className='single-student-info-classroom-list__item'>
                  <p className='single-student-info-classroom-list__item-heading'>
                    {classroom.getName()}
                  </p>
                  <span className='single-student-info-classroom-list__item-body'>{teachers}</span>
                </div>
              </Link>
            );
          })}
      </div>
    );
  }

  render() {
    return (
      <div className='single-student-info'>
        <div className='single-student-info-card single-student-info-card--info'>
          <h4 className='single-student-info-card-heading'>Contact</h4>
          {this.makeInformationList()}
        </div>
        <div className='single-student-info-card single-student-info-card--classrooms'>
          <h4 className='single-student-info-card-heading'>Classrooms</h4>
          {this.makeClassroomsList()}
        </div>
      </div>
    );
  }
}
